import type { GWSnapshot } from '@/app/(dashboard)/saas-inventory/google-workspace/snapshotTypes';

export const snapshotsMockData: GWSnapshot[] = [
  {
    id: 'snap-20260405',
    date: '2026-04-05T04:00:00Z',
    label: 'Apr 5, 2026 (Latest)',
    sizeBytes: 39_191_576_576,
    userCount: 5,
    sharedDriveCount: 3,
  },
  {
    id: 'snap-20260401',
    date: '2026-04-01T04:00:00Z',
    label: 'Apr 1, 2026',
    sizeBytes: 37_044_092_928,
    userCount: 5,
    sharedDriveCount: 3,
  },
  {
    id: 'snap-20260325',
    date: '2026-03-25T04:00:00Z',
    label: 'Mar 25, 2026',
    sizeBytes: 34_359_738_368,
    userCount: 5,
    sharedDriveCount: 3,
  },
  {
    id: 'snap-20260315',
    date: '2026-03-15T04:00:00Z',
    label: 'Mar 15, 2026',
    sizeBytes: 30_064_771_072,
    userCount: 5,
    sharedDriveCount: 3,
  },
];

/**
 * IDs of nodes to remove per snapshot to simulate changes over time.
 * The latest snapshot (Apr 5) has all data.
 * Older snapshots progressively remove newer content.
 */
export const snapshotRemovals: Record<string, string[]> = {
  'snap-20260405': [],
  'snap-20260401': [
    // Q2 content didn't exist yet on Apr 1
    'sd-001-f01-f02', // Q2 2026 folder in Campaigns
    'sd-002-f03-002', // Sprint Retro 2026-04-05.docx
    'user-001-gd-f01-f01-003', // Notes.gdoc (Apr 3)
    '19d0b1a781d99b12', // Dana: Re: Q2 Planning Meeting (Apr 4)
    '19d0a8e3c2f44a01', // Dana: Invoice #4821 (Apr 4)
    '19d0b2cc44aa1100', // Mira: Re: Q2 Planning Meeting (Apr 4)
    '19d0a5ee33bb2211', // Mira: Design Review Tomorrow (Apr 3)
  ],
  'snap-20260325': [
    // Everything from Apr 1 removals plus more
    'sd-001-f01-f02',
    'sd-002-f03-002',
    'user-001-gd-f01-f01-003',
    '19d0b1a781d99b12',
    '19d0a8e3c2f44a01',
    '19d0b2cc44aa1100',
    '19d0a5ee33bb2211',
    // Late March content
    'sd-002-f02-f01-002', // 2026-03-22 DB Failover.gdoc
    'user-001-gd-f01-f01-f01-001', // Dashboard_v2.fig (Mar 30)
    'user-001-gd-004', // meeting-recording-2026-03-30.mp4
    'sd-003-f02-001', // Q1 2026 Financial Summary.xlsx (Apr 2)
    'sd-003-f02-f01-002', // Board Deck Q1 2026.pptx (Apr 2)
    '19d09f12ab8c7e55', // Dana: Weekly Engineering Digest (Apr 3)
    '19d08a44de3b1c90', // Dana: Backup Status Report (Apr 2)
    '19d07bc901a2df44', // Dana: Re: API Integration Feedback (Apr 2)
    '19d06a1178c3ee02', // Dana: Board Deck Review (Apr 1)
  ],
  'snap-20260315': [
    // Everything from Mar 25 plus more
    'sd-001-f01-f02',
    'sd-002-f03-002',
    'user-001-gd-f01-f01-003',
    '19d0b1a781d99b12',
    '19d0a8e3c2f44a01',
    '19d0b2cc44aa1100',
    '19d0a5ee33bb2211',
    'sd-002-f02-f01-002',
    'user-001-gd-f01-f01-f01-001',
    'user-001-gd-004',
    'sd-003-f02-001',
    'sd-003-f02-f01-002',
    '19d09f12ab8c7e55',
    '19d08a44de3b1c90',
    '19d07bc901a2df44',
    '19d06a1178c3ee02',
    // Events / SaaStr folder
    'sd-001-f03',
    // Late March files
    'sd-002-f01-001', // System Design.pdf (Mar 28)
    'sd-002-f03-001', // Sprint Retro 2026-03-29.docx
    'user-001-gd-f01-f01-002', // Wireframes.fig (Mar 28)
    'user-002-gd-f02-001', // Mockups_v3.fig (Mar 22)
    'user-003-gd-f01-001', // Performance Benchmarks.gsheet (Mar 30)
    '19d05123aabb4410', // Dana: New Hire Onboarding (Mar 31)
    '19d04015cc7890ab', // Dana: Signed: MSA (Mar 30)
    '19d0b5aa11cc3344', // Kai: Re: API Integration Feedback (Apr 2)
    '19d0a3bb22dd4455', // Kai: GitHub PR merged (Apr 1)
    '19d09244cc556677', // Kai: PagerDuty Incident (Mar 31)
  ],
};
